import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 24 24",
    color: "#193446",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M11.175 11.29V2.784c0-.433.344-.784.768-.784s.767.351.767.784v8.506h8.506c.433 0 .784.343.784.767a.776.776 0 0 1-.784.768H12.71v8.39a.776.776 0 0 1-.767.785.776.776 0 0 1-.768-.784v-8.391h-8.39A.776.776 0 0 1 2 12.057c0-.424.351-.767.784-.767z" fill="currentColor"/>' }
  })
);